import React from 'react';
import { FaChartLine, FaStar, FaBullseye, FaTasks } from 'react-icons/fa';
import './MetricsBar.css';

export default function MetricsBar({ progress, score, objectives, keyResults }) {
  const getScoreLabel = (score) => {
    if (score < 0.5) return 'Low';
    if (score < 0.8) return 'Medium';
    return 'High';
  };
  
  const scoreColor = score < 0.5 ? '#D32F2F' : score < 0.8 ? '#F57C00' : '#2E7D32';
  
  return (
    <div className="m3-metrics-bar">
      <div className="m3-metric-chip">
        <FaChartLine className="m3-metric-icon" />
        <div className="m3-metric-content">
          <span className="m3-metric-label">Progress</span>
          <span className="m3-metric-value">{progress}%</span>
        </div>
        <div className="m3-circular-progress" style={{ '--progress': `${progress}%` }}>
          <svg viewBox="0 0 36 36" className="m3-progress-ring">
            <circle
              className="m3-progress-ring-background"
              cx="18"
              cy="18"
              r="16"
              fill="none"
              stroke="#E0E0E0"
              strokeWidth="3"
            />
            <circle
              className="m3-progress-ring-fill"
              cx="18"
              cy="18"
              r="16"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeDasharray={`${progress}, 100`}
              strokeLinecap="round"
              transform="rotate(-90 18 18)"
            />
          </svg>
        </div>
      </div>
      
      <div className="m3-metric-chip">
        <FaStar className="m3-metric-icon" style={{ color: scoreColor }} />
        <div className="m3-metric-content">
          <span className="m3-metric-label">Score</span>
          <span className="m3-metric-value" style={{ color: scoreColor }}>
            {score.toFixed(1)} ({getScoreLabel(score)})
          </span>
        </div>
      </div>
      
      <div className="m3-metric-chip">
        <FaBullseye className="m3-metric-icon" />
        <div className="m3-metric-content">
          <span className="m3-metric-label">Objectives</span>
          <span className="m3-metric-value">{objectives}</span>
        </div>
      </div>
      
      <div className="m3-metric-chip">
        <FaTasks className="m3-metric-icon" />
        <div className="m3-metric-content">
          <span className="m3-metric-label">Key Results</span>
          <span className="m3-metric-value">{keyResults}</span>
        </div>
      </div>
    </div>
  );
}

